export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=An%20elegant%20dark%20abstract%20background%20with%20flowing%20golden%20and%20amber%20light%20streaks%20on%20a%20deep%20charcoal%20canvas%2C%20premium%20warm%20glowing%20particles%20floating%20gently%2C%20sophisticated%20luxurious%20atmosphere%20with%20soft%20radial%20golden%20glow%20in%20center%2C%20suitable%20for%20call%20to%20action%20section%20of%20a%20premium%20platform%20website&width=1800&height=600&seq=cta-bg-52662&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left" id="download">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
              准备好体验<br />
              <span className="text-primary-400">鼎盛平台的魅力</span>了吗？
            </h2>
            <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-lg mb-8">
              立即下载官方正版客户端，注册即享新用户专属福利。
              安全、稳定、高效，鼎盛平台期待您的加入！
            </p>
            <div className="flex flex-col sm:flex-row items-center lg:items-start gap-3">
              <a
                href="#download"
                className="whitespace-nowrap px-8 py-3.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-400 transition-all duration-300 cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-download-line text-lg" />
                官方正版下载
              </a>
              <a
                href="#register"
                id="register"
                className="whitespace-nowrap px-8 py-3.5 rounded-full text-sm font-semibold border border-white/30 text-white hover:bg-white/10 hover:border-white/50 transition-all duration-300 cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-user-add-line text-lg" />
                立即注册
              </a>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative w-72 h-72 md:w-80 md:h-80">
              <div className="absolute inset-0 rounded-full bg-primary-500/10 animate-pulse" />
              <div className="absolute inset-4 rounded-full bg-primary-500/5" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                    <i className="ri-download-cloud-2-line text-3xl md:text-4xl text-primary-400" />
                  </div>
                  <p className="text-white/70 text-sm mb-2">扫码下载官方APP</p>
                  <p className="text-primary-400 text-xs">iOS / Android 通用</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}